import {useContext} from 'react'
import {DynamicTable} from '../../../../components/DynamicTable'
import {BadgeProductsContext} from '../../context'
import BadgeProductsTableRow from './BadgeProductsTableRow'
import { parseProductData } from '../../parsings'

const tableColumns = [
  {
    key: 'sku',
    label: 'SKU',
    headerStyle: 'min-w-150px',
    isSorted: true,
    isSearchable: true,
  },
  {
    key: 'name',
    label: 'Product',
    headerStyle: 'min-w-400px',
    isSorted: true,
    isSearchable: true,
  },
  {
    key: 'category',
    label: 'Category',
    headerStyle: 'min-w-200px',
  },
  {
    key: 'brand',
    label: 'Brand',
    headerStyle: 'min-w-150px',
  },
  {
    key: 'action',
    label: 'Action',
    headerStyle: 'w-80px text-center',
  },
]

const BadgeProductsTable = () => {
  const {products, isLoading, filters, onSortingChange,  setCheckedRows, hasWritePermission} =
    useContext(BadgeProductsContext)

  return (
    <DynamicTable
      id='badge-products-table'
      data={products}
      sortableColumns={tableColumns}
      TableRow={BadgeProductsTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      setCheckedRows={setCheckedRows}
      checkedRowId='sku'
      rowParsingFunction={parseProductData}
      hasPermission={hasWritePermission}
      requiredOutputKeys={['id', 'sku']}
      tableClass='table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-15'
      tableHeaderClass='table-row-bordered'
      noDataMessage='No products found'
    />
  )
}

export default BadgeProductsTable
